import React from 'react';
import PropTypes from 'prop-types';
import { Link } from 'react-router-dom';
import styles from './Tag.module.scss';

const Tag = ({ children, id, handleSaveCheckedTags }) => (
  <li className={styles.bns3_tag}>
    <Link
      to={{
        pathname: '/',
        search: `?tagIds=${id}`,
      }}
      onClick={handleSaveCheckedTags}
    >
      { children }
    </Link>
  </li>
);

Tag.propTypes = {
  id: PropTypes.number.isRequired,
  handleSaveCheckedTags: PropTypes.func.isRequired,
  children: PropTypes.node.isRequired,
};

export default Tag;
